// extracted by mini-css-extract-plugin
export var alt = "SearchBar-module--alt--e280d";
export var desktopOnly = "SearchBar-module--desktopOnly--1f530";
export var header = "SearchBar-module--header--99d6d";
export var headerMobileHidden = "SearchBar-module--headerMobileHidden--2554f";
export var headerMobileVisible = "SearchBar-module--headerMobileVisible--b7931";
export var main = "SearchBar-module--main--578c1";
export var mobileOnly = "SearchBar-module--mobileOnly--b85bd";
export var row = "SearchBar-module--row--ad7d1";
export var searchWrapper = "SearchBar-module--searchWrapper--81c0f";
export var stickyContainer = "SearchBar-module--stickyContainer--1af71";
export var stickyHeader = "SearchBar-module--sticky-header--7f1fb";
export var stripeColor = "SearchBar-module--stripeColor--7dba7";
export var textLeft = "SearchBar-module--textLeft--214d9";
export var visuallyHidden = "SearchBar-module--visuallyHidden--c4bc4";